import {BlueshiftAPIConnectorError, restfulApiClient} from "./api.ts";
import {et} from "../locales/i18n.tsx";

export class KeypairAPIConnectorError extends BlueshiftAPIConnectorError {
    public readonly localization;


    constructor(err: BlueshiftAPIConnectorError, localization: string) {
        super(err.cause, err.message);

        this.localization = localization;
    }
}

class KeypairRes {
    public readonly privateKeyContent: string;
    public readonly privateKeyFileName: string;
    public readonly privateKeyContentType: string;

    constructor(privateKeyContent: string, privateKeyFileName: string, privateKeyContentType: string) {
        this.privateKeyContent = privateKeyContent;
        this.privateKeyFileName = privateKeyFileName;
        this.privateKeyContentType = privateKeyContentType;
    }

    download() {
        const blob = new Blob([this.privateKeyContent], {type: this.privateKeyContentType});
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');


        link.href = url;
        link.download = this.privateKeyFileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    }
}

export const keypair = {
    async get() {
        try {
            return await restfulApiClient.get("keypair", 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new KeypairAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async generate(name: string, isDefault: boolean, password: string) {
        try {
            const res = await restfulApiClient.post("keypair", 1, {
                name: name,
                default: isDefault,
                password: password,
            });

            return new KeypairRes(res!.data as string, `${name}.pem`, res!.headers["content-type"]);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new KeypairAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async delete(name: string) {
        try {
            return await restfulApiClient.delete(`keypair/${name}`, 1);
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new KeypairAPIConnectorError(err, et(err.cause));
            }
            throw err;
        }
    },

    async upload(name: string, isDefault: boolean, privateKey: File, publicKey: File, password: string) {
        const formData = new FormData();
        formData.append("password", password);
        formData.append("default", isDefault.toString());

        formData.append("private_key", privateKey);
        formData.append("public_key", publicKey);
        try {
            return await restfulApiClient.put(
                `keypair/${name}`,
                1,
                formData,
            );
        } catch (err) {
            console.log(err);
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new KeypairAPIConnectorError(err, et(err.cause));
            }

            throw err;
        }
    },
    async setDefault(name: string) {
        try {
            return await restfulApiClient.patch(
                `keypair/${name}`,
                1,
                {default: true}
            );
        } catch (err) {
            if (err instanceof BlueshiftAPIConnectorError) {
                throw new KeypairAPIConnectorError(err, et(err.cause));
            }

            throw err;
        }
    }
}